module.exports = __webpack_public_path__ + "static/media/27.c13cbd15.jpg";